export const formatSecondsToMinutes = seconds => {
  const timeRoundedDown = Math.floor(seconds);
  const minutes = Math.floor(timeRoundedDown / 60);
  const remainingSeconds = timeRoundedDown % 60;

  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};

export const roundUpSecondsToMinutes = seconds => Math.ceil(+seconds / 60);
